<template>
  <div class="w-56 shrink-0">
    <RichSelectField
      :aria-label="t('Reviews.product.insights.filters.timeframe.label')"
      size="s"
      :model-value="timeframe"
      data-testid="insights-timeframe-button"
      @update:model-value="onSelect"
    >
      <template #prepend>
        <CalendarIcon class="lucide-icon-s" />
      </template>
      <RichSelectOption
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :label="option.text"
        :data-testid="`insights-timeframe-option-${option.value}`"
      />
    </RichSelectField>
  </div>
</template>

<script setup lang="ts">
import { RichSelectField, RichSelectOption } from '@ramp106/omrjs-core-ui'
import { CalendarIcon } from '@ramp106/omrjs-core-ui/icons'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { checkEnumValue } from '@/helpers/checkEnumValue'

import { InsightsTimeframe } from './insightsTimeframe'
import { useRouterQueryInsightsTimeframe } from './useRouterQueryInsightsTimeframe'

const { t } = useI18n()
const { timeframe, setTimeframe } = useRouterQueryInsightsTimeframe()

const options = computed(() =>
  Object.values(InsightsTimeframe).map((value) => ({
    value,
    text: t(`Reviews.product.insights.filters.timeframe.options.${value}`),
  })),
)

function onSelect(value: string | string[]) {
  if (!Array.isArray(value)) setTimeframe(checkEnumValue(value, InsightsTimeframe, timeframe.value))
}
</script>
